(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jackie-codex-world-cup-lower"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pruneDuplicateKlaviyoForms = (embed) => {
      const forms = Array.from(embed.querySelectorAll('form'));
      if (forms.length < 2) return;

      forms.slice(1).forEach((form) => {
        let node = form;
        while (node.parentElement && !node.parentElement.classList.contains('jc-klaviyo-embed') && node.parentElement.children.length === 1) {
          node = node.parentElement;
        }
        node.remove();
      });
    };

    const watchEmbed = (embed) => {
      pruneDuplicateKlaviyoForms(embed);
      new MutationObserver(() => pruneDuplicateKlaviyoForms(embed)).observe(embed, { childList: true, subtree: true });
    };

    document.querySelectorAll('.jc-wc-lower .jc-klaviyo-embed').forEach(watchEmbed);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.jc-wc-lower .jc-klaviyo-embed').forEach(watchEmbed);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
